import { Card, Typography, Space } from "antd";
import { motion } from "framer-motion";

const { Text, Title } = Typography;

const SoftSkillList = ({ data, color = "#00D9FF", title }) => {
  return (
    <Card
      style={{
        background: "#ffffff",
        border: `1px solid var(--card-border)`,
        borderRadius: "var(--radius)",
        boxShadow: `8px 8px 0px var(--bg-dark)`,
        height: "100%",
      }}
      bodyStyle={{ padding: "24px" }}
    >
      {title && (
        <Title level={4} style={{ color: "var(--bg-dark)", marginBottom: 24, fontWeight: 800, textTransform: "uppercase" }}>
          {title}
        </Title>
      )}
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        {data.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.1 }}
          >
            <div style={{ marginBottom: 8 }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
                <Text style={{ color: "var(--text-primary)", fontSize: "14px", fontWeight: 600 }}>
                  {item.skill}
                </Text>
                <Text style={{ color: "var(--primary-color)", fontWeight: "bold" }}>
                  {item.level}/10
                </Text>
              </div>
              <div
                style={{
                  width: "100%",
                  height: "10px",
                  background: "var(--bg-light)",
                  border: "1px solid var(--card-border)",
                  borderRadius: "var(--radius)",
                  overflow: "hidden",
                }}
              >
                <motion.div
                  initial={{ width: 0 }}
                  whileInView={{ width: `${(item.level / 10) * 100}%` }}
                  transition={{ duration: 1, delay: index * 0.1 }}
                  style={{
                    height: "100%",
                    background: "var(--primary-color)",
                    borderRadius: "0px",
                  }}
                />
              </div>
            </div>
          </motion.div>
        ))}
      </Space>
    </Card>
  );
};

export default SoftSkillList;
